// extracted by mini-css-extract-plugin
module.exports = {"description":"terms_description__lxk0M","bullet":"terms_bullet__x0b2J","check":"terms_check__STuyp","label":"terms_label___bXiH"};